<h4 class="font-bold mt-5">Riepilogo</h4>
<div class="grid grid-cols-12 gap-3">
   <div class="table_responsive col-span-12">
      <table class="min-w-full divide-y divide-gray-300 tbl-header-dark">
         <thead>

         <tr>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Prodotto</th>
            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-center">QTA:</th>
            <th *ngIf="hasTotals"  scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">Importo listino:</th>
            <th *ngIf="hasTotals"  scope="col" class="px-3 py-3.5 text-sm font-semibold text-center">Sconto:</th>
            <th *ngIf="hasTotals"  scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">Da addebitare:</th>
            <th *ngIf="hasTotals && tipoRettifica != ''"  scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">Totale pagato:</th>
         </tr>

         </thead>

         <tbody class="divide-y divide-gray-200 bg-white" *ngIf="ordiniSlave.length > 0">
         <tr *ngFor="let inst of ordiniSlave; let index = index;">
            <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900">
               <li class="flex space-x-6 py-2">
                  <div class="flex-auto space-y-1">
                     <div class="text-gray-900"><span>{{index+1}}- </span><a>{{inst.PROD_DISPLAY}}</a></div>
                     <div *ngIf="inst?.data?.vendor_prod_var_instance">
                        <p>Misura: <span>{{inst?.data?.vendor_prod_var_instance.metrica_str}}</span>, <span>{{inst?.data?.ean}}</span></p>
                     </div>
                     <div *ngIf="!inst?.data?.vendor_prod_var_instance">
                        <p><span>{{inst?.data?.label_product}}</span></p>
                     </div>

                  </div>
               </li>
            </td>
            <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-center"
                [ngClass]="inst?.data?.qta! > 0 ? 'text-gray-500' : 'text-red-600 font-semibold'">
               {{inst?.data?.qta}}
               <div><span *ngIf="inst?.data.qta_reso > 0" class="font-bold text-red-500">(Resi: {{inst?.data.qta_reso}})</span></div>
            </td>
            <td *ngIf="hasTotals"  class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{inst?.data?.total_gross | currency:'€'}}</td>
            <td *ngIf="hasTotals"  class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-center">{{inst?.data?.sconto}} %</td>
            <td *ngIf="hasTotals"  class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{inst?.data?.total | currency:'€'}}</td>
            <td *ngIf="hasTotals && tipoRettifica == TIPO_RETTIFICA.AMMANCHI" class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{inst?.data?.prezzo_acquisto_max | currency:'€'}}</td>
            <td *ngIf="hasTotals && tipoRettifica == TIPO_RETTIFICA.ESUBERI" class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{inst?.data?.prezzo_acquisto_min | currency:'€'}}</td>
         </tr>

         <tr *ngFor="let sconto of ordine.data.sconti_ordini; let index = index;">
            <td colspan="3" class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900">{{sconto.riga}} -
               <ng-container *ngFor="let tipo of Ordine.TipoSconto">
                  <span *ngIf="tipo.value == sconto.tipo">{{tipo.display}}</span>
               </ng-container>
            </td>
            <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-center">{{sconto.sconto}} <ng-container *ngIf="sconto.tipo == Ordine.TipoScontoChoices.PERCENTUALE; else flat">%</ng-container></td>
            <ng-template #flat>€</ng-template>
            <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{sconto.valore_sconto}} €</td>
         </tr>

         <tr *ngFor="let sped of ordine.data.spedizioni_ordini; let index = index;">
            <td colspan="4" class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900">{{index + 1}}- Spedizione</td>
            <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{sped.total | currency:'€'}}<td>
         </tr>
         </tbody>

         <thead>
         <tr class="">
            <td class=""></td>
            <td scope="col" class="px-3 py-1 text-sm font-semibold text-center">Qta tot</td>
            <td *ngIf="hasTotals"  colspan="1" class="px-3 py-1 text-sm font-semibold text-right">Totale lordo prodotti</td>
            <td *ngIf="!hasTotals" colspan="4"></td>
            <td *ngIf="hasTotals"  colspan="2"></td>
            <td *ngIf="hasTotals && tipoRettifica != ''" colspan="1"></td>
         </tr>
         </thead>

         <tbody class="divide-y divide-gray-200 bg-white" *ngIf="ordiniSlave.length > 0">

         <tr>
            <td class="whitespace-nowrap px-3 py-2 font-bold"></td>
            <td class="whitespace-nowrap px-3 py-2 font-bold text-center">{{qtaTot}}</td>
            <td *ngIf="hasTotals" colspan="1" class="whitespace-nowrap px-3 py-2 text-sm font-bold text-right">{{ordine.data.total_gross | currency:'€'}}</td>
            <td *ngIf="!hasTotals" colspan="4"></td>
            <td *ngIf="hasTotals" colspan="2"></td>
            <td *ngIf="hasTotals && tipoRettifica != ''" colspan="1"></td>
         </tr>

         <tr *ngIf="hasTotals">
            <td colspan="3" class="whitespace-nowrap px-3 py-2 font-bold"></td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-medium text-ibm-secondary-300 text-right">Imponibile</td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-medium text-ibm-secondary-300 text-right">{{ordine.data.imponibile | currency:'€'}}</td>
            <td *ngIf="tipoRettifica != ''" colspan="1"></td>
         </tr>

         <tr *ngIf="hasTotals">
            <td colspan="3" class="whitespace-nowrap px-3 py-2 font-bold"></td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-medium text-ibm-secondary-300 text-right">Iva ({{ordine.data.iva}}%)</td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-medium text-ibm-secondary-300 text-right">{{ordine.data.total_tax | currency:'€'}}</td>
            <td *ngIf="tipoRettifica != ''" colspan="1"></td>
         </tr>

         <tr *ngIf="hasTotals">
            <td colspan="3" class="whitespace-nowrap px-3 py-2 font-bold"></td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-bold text-right">Totale</td>
            <td class="whitespace-nowrap px-3 py-2 text-sm font-bold text-right">{{ordine.data.total | currency:'€'}}</td>
            <td *ngIf="tipoRettifica == TIPO_RETTIFICA.AMMANCHI" class="whitespace-nowrap px-3 py-2 text-sm font-bold text-right">{{ordine.data.total_acquisto_max | currency:'€'}}</td>
            <td *ngIf="tipoRettifica == TIPO_RETTIFICA.ESUBERI" class="whitespace-nowrap px-3 py-2 text-sm font-bold text-right">{{ordine.data.total_acquisto_min | currency:'€'}}</td>
         </tr>

         </tbody>
      </table>
   </div>

</div>
